const StatCard = ({ title, value, note, tone = "sunset", icon: Icon }) => {
  return (
    <div className="stat-card rise-in" data-tone={tone}>
      <div className="stat-card__meta">
        <span className="stat-card__label">{title}</span>
        {note ? <span className="stat-card__note">{note}</span> : null}
      </div>
      <div className="stat-card__value-wrap">
        <strong className="stat-card__value">{value}</strong>
        <span className="stat-card__accent" aria-hidden="true">
          {Icon ? <Icon /> : null}
        </span>
      </div>
    </div>
  );
};

export default StatCard;
